export const HRV_CAPTURE_STATE_STATUS = "status"
export const HRV_CAPTURE_STATE_PROGRESS = "progress"
export const HRV_CAPTURE_STATE_COMPLIANCE = "compliance"
export const HRV_CAPTURE_STATE_DATA = "data"
export const HRV_CAPTURE_STATE_FRAME_DROP_COMPLIANCE_ERROR_COUNT = 'frameDropComplianceErrorCount'
export const HRV_CAPTURE_STATE_TASK_PROGRESS = "taskProgress"
export const HRV_CAPTURE_STATE_TASK_MAX_PROGRESS = "taskMaxProgress"
export const HRV_CAPTURE_STATE_IS_RECONFIGURING_CAMERA = 'isReconfiguringCamera'
export const HRV_CAPTURE_STATE_IS_LOW_POWER_MODE_ENABLED = 'isLowPowerModeEnabled'